module.exports = __webpack_public_path__ + "static/media/599.767 (6).b1e25658.pdf";